/**
 * Dealer Manage : 经销商管理
 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/third-adapter/v1/{organizationId}',
  items: [
    {
      key: 'addThirdConfigs',
      url: '/third-configs',
      method: 'POST',
    },
    {
      key: 'getThirdConfigs',
      url: '/third-configs',
      method: 'GET',
    },
    {
      key: 'deleteThirdConfigs',
      url: '/third-configs',
      method: 'DELETE',
    },
    {
      key: 'putThirdConfigs',
      url: '/third-configs',
      method: 'PUT',
    },
    {
      key: 'getThirdConfigsDetail',
      url: '/third-configs/{id}',
      method: 'GET',
    },
  ],
};

export default {
  ...generate(config),
};
